export { useRecommendedCompanies } from './useRecommendedCompanies';
